module.exports = __webpack_public_path__ + "static/img/2.de9ece1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.png
// module id = NKGv
// module chunks = 0